import { Action } from '@ngrx/store';

export enum JobActionTypes {
    JOB_STATUS = '[Job] Status',
    JOB_STATUS_SUCCESS = '[Job] Status Success',
    JOB_STATUS_FAILURE = '[Job] Status Failure',
}

export class JobStatus implements Action {
    readonly type = JobActionTypes.JOB_STATUS;
}

export class JobStatusSuccess implements Action {
    readonly type = JobActionTypes.JOB_STATUS_SUCCESS;
    constructor(public payload: any) {} // Update the payload type with the actual data type returned by JoblockService.getCurrentLoadPercentage()
}

export class JobStatusFailure implements Action {
    readonly type = JobActionTypes.JOB_STATUS_FAILURE;
    constructor(public payload: any) {}
}

export type JobActions = JobStatus | JobStatusSuccess | JobStatusFailure;
